<template>
  <div>
    <div class="button" @click="onClick">
      <a-icon type="shrink" style="font-size: 18px" />
      <div>缩小地图</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("mapTools", ["min"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setMin"]),
    onClick() {
      this.setMin(this.min - 1);
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}
</style>